import { Link, createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { InDevelopment } from '@lunary/ui-web/in-development'

export const deckRoute = createRoute({
  path: 'deck',
  getParentRoute: () => rootRoute,
  component: () => (
    <InDevelopment
      icon="deck"
      title="Колода"
      text="Здесь будут все 78 карт с прямыми и перевёрнутыми значениями. Раздел скоро откроется."
    >
      <Link to="/daily-card">
        <button type="button">К карте дня</button>
      </Link>
    </InDevelopment>
  ),
})
